import { usePageProps } from '../Homepage/Homepage.hooks'

export function useCategories() {
    const { categories } = usePageProps()
    return { categories };
}